import { render, staticRenderFns } from "./phonetic_alphabet_recognition.vue?vue&type=template&id=2f5a62fc&scoped=true"
import script from "./phonetic_alphabet_recognition.vue?vue&type=script&lang=js"
export * from "./phonetic_alphabet_recognition.vue?vue&type=script&lang=js"
import style0 from "./phonetic_alphabet_recognition.vue?vue&type=style&index=0&id=2f5a62fc&prod&lang=css"
import style1 from "./phonetic_alphabet_recognition.vue?vue&type=style&index=1&id=2f5a62fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a62fc",
  null
  
)

export default component.exports